<template>
    <b-container fluid="">
        <b-row>
            <div class="col-sm-12 mt-3">
                <h3>
                    Solicitudes de descuento
                </h3>
            </div>
            <div class="col-sm-12 mt-1">
                <b-tabs content-class="mt-3" fill>
                    <b-tab title="Pendientes" active 
                        v-if="permisos['solicitud_descuento.aprobadas']?.ver || datos_usuario.parametros.roles.includes('ROOT')"
                        @click="set_modulo('pendientes')">
                    </b-tab>
                    <b-tab title="Aprobadas" 
                        v-if="permisos['solicitud_descuento.pendientes']?.ver || datos_usuario.parametros.roles.includes('ROOT')"
                        @click="set_modulo('aprobados')">
                    </b-tab>
                    <b-tab title="Rechazadas" 
                        v-if="permisos['solicitud_descuento.rechazadas']?.ver || datos_usuario.parametros.roles.includes('ROOT')"
                        @click="set_modulo('rechazadas')">
                    </b-tab>
                </b-tabs>
            </div>
        </b-row>

        <Pendientes v-if="modulo == 'pendientes'" />
        <Aprobados v-if="modulo == 'aprobados'" />
        <Rechazados v-if="modulo == 'rechazadas'" />

    </b-container>
</template>

<script>
    import Pendientes from './Pendientes/Pendientes.vue'
    import Aprobados from './Aprobados/Aprobados.vue'
    import Rechazados from './Rechazados/Rechazados.vue'
import { mapState } from 'vuex'

    export default {
        name: 'Listado',
        components: {
            Pendientes,
            Aprobados,
            Rechazados
        },
        computed: {
            ...mapState(['permisos', 'datos_usuario'])
        },
        data() {
            return {
                modulo: 'pendientes'
            }
        },
        methods: {
            set_modulo(modulo) {
                this.modulo = modulo
            }
        },
        mounted() {
            if (this.permisos['solicitud_descuento.aprobadas']?.ver) {
                this.modulo == 'pendientes'
            }else if (this.datos_usuario.parametros.roles.includes('ROOT')) {
                this.modulo = 'pendientes'
            }else{
                this.modulo = ''
            }
        },
    }
</script>

<style></style>